import Cookies from 'js-cookie';

const isNeedSaveToCache = (cookieKey, query) => Cookies.get(cookieKey) !== query;

export const deleteKeyFromCache = key => Cookies.remove(key);

export const setQueryToCache = (cookieKey, query, options = {}) => isNeedSaveToCache(cookieKey, query) && Cookies.set(cookieKey, query, options);

export const getQueryFromCache = cookieKey => Cookies.get(cookieKey);
